import { render } from "./NetworkSettings.vue?vue&type=template&id=2a6b835f&scoped=true"
import script from "./NetworkSettings.vue?vue&type=script&lang=js"
export * from "./NetworkSettings.vue?vue&type=script&lang=js"

import "./NetworkSettings.vue?vue&type=style&index=0&id=2a6b835f&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/sb.web.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a6b835f"]])

export default __exports__